import { orgSelectors } from 'ducks/orgs'
import React from 'react'
import { SelectInput } from 'react-admin'
import { useSelector } from 'react-redux'
import styles from 'styles'
interface PropTypes {
  label: string
  source: string
}

const SharedWithInput: React.FC<PropTypes> = ({ label, source }) => {
  const connectedOrgs = useSelector(orgSelectors.getConnectedOrgs)
  if (!!!connectedOrgs.length) {
    return <></>
  }
  return (
    <SelectInput
      label={label || 'Shared With'}
      choices={connectedOrgs}
      optionText={'org_name'}
      optionValue={'org_id'}
      options={{
        style: styles.FILTER_FIELD_STYLE,
        placeholder: 'Enter an org name',
      }}
      source={source || 'shared_with'}
    />
  )
}

export default SharedWithInput
